module.exports = __webpack_public_path__ + "img/tokenBox21.17e20a12.png";